import React, { useState, useEffect } from 'react';
import { DateTime } from 'luxon';
import numeral from 'numeral';
import { connect } from 'react-redux';
import { setFilterCriteria, setFilteredItems } from './CourtDistAction';
import styled from 'styled-components';

const commafy = aNumber => numeral(aNumber).format('0,0');

const Filter = props => {
  const f = props.filterCriteria;
  const [courtTypeFilter, setCourtTypeFilter] = useState(f.courtTypeFilter || '');
  const [judDistrictFilter, setJudDistrictFilter] = useState(f.judDistrictFilter || '');
  const [descFilter, setDescFilter] = useState(f.descFilter || '');
  const [cityFilter, setCityFilter] = useState(f.cityFilter || '');
  const [notExpFilter, setNotExpFilter] = useState(f.notExpFilter || true);
  const [expiredFilter, setExpiredFilter] = useState(f.expiredFilter || false);
  
  const filterCriteria = {
    courtTypeFilter,
    judDistrictFilter,
    descFilter,
    cityFilter,
    notExpFilter,
    expiredFilter,
  };

  const courtTypeFilterChanged = newValue => {
    setCourtTypeFilter(newValue);
    props.setFilterCriteria({...filterCriteria, courtTypeFilter: newValue});
  };
  const judDistrictFilterChanged = newValue => {
    setJudDistrictFilter(newValue);
    props.setFilterCriteria({...filterCriteria, judDistrictFilter: newValue});
  };
  const descFilterChanged = newValue => {
    setDescFilter(newValue);
    props.setFilterCriteria({...filterCriteria, descFilter: newValue});
  };
  const cityFilterChanged = newValue => {
    setCityFilter(newValue);
    props.setFilterCriteria({...filterCriteria, cityFilter: newValue});
  };
  const notExpFilterChanged = newValue => {
    setNotExpFilter(newValue);
    props.setFilterCriteria({...filterCriteria, notExpFilter: newValue});
  };
  const expiredFilterChanged = newValue => {
    setExpiredFilter(newValue);
    props.setFilterCriteria({...filterCriteria, expiredFilter: newValue});
  };

  // This effect re-filters the result set based on updated
  // filter values.
  //
  function filterTextField(filterValue, fieldValue) {
    let keepEntry = true;
    if (filterValue) {
      if (fieldValue) {
        const ucFieldValue  = fieldValue.toUpperCase();
        const ucFilterValue = filterValue.toUpperCase();
        keepEntry = ucFieldValue.startsWith(ucFilterValue);
      } else {
        keepEntry = false;
      }
    }
    return keepEntry
  }

  function filterExpired(includeExpired, includeNotExpired, fieldValue) {
    let expired = false;
    const expDate  = DateTime.fromISO(fieldValue);
    if (expDate.isValid) {
      const today = DateTime.now();
      expired = expDate < today;
    }
    const keepEntry = ( expired && includeExpired)
                   || (!expired && includeNotExpired);
    return keepEntry;
  }
  useEffect(() => {
    const selectedItems = props.items.filter(item => 
         filterTextField(courtTypeFilter,   item.court_type)
      && filterTextField(judDistrictFilter, item.judicial_district)
      && filterTextField(descFilter,        item.description)
      && filterTextField(cityFilter,        item.city)
      && filterExpired(expiredFilter, notExpFilter, item.exp_date)
    ).sort((a,b) => a.judicial_district < b.judicial_district ? -1 : 0);
    props.setFilteredItems(selectedItems);
  }, [ 
    courtTypeFilter,
    judDistrictFilter,
    descFilter,
    cityFilter,
    notExpFilter,
    expiredFilter,
    props.items.length
  ]);
  
  return (
    <fieldset style={{width: 'min-content'}}>
      <legend>Court District Filters</legend>
      <FilterSection>
        <div>
          <MediumField>
            <label>Court Type</label>
            <select type="select"
                    tabIndex="1"
                    id="court_type"
                    value={courtTypeFilter}
                    onChange={e => courtTypeFilterChanged(e.target.value)} >
              <option value="">Any</option>
              <option value="M">M – Municipal</option>
              <option value="S">S – Superior</option>
              <option value="X">X – Juvenile</option>
              <option value="J">J – Justice</option>
              <option value="P">P – Parole</option>
            </select>
          </MediumField>
          <MediumField>
            <label>Judicial District</label>
            <input type="text"
                   tabIndex="2"
                   id="judicial_district"
                   size="3"
                   value={judDistrictFilter}
                   onChange={e => judDistrictFilterChanged(e.target.value)} />
          </MediumField>
        </div>
        <div>
          <MediumField>
            <label>Description</label>
            <input type="text"
                   tabIndex="3"
                   id="description"
                   size="12"
                   value={descFilter}
                   onChange={e => descFilterChanged(e.target.value)} />
          </MediumField>
          <MediumField>
            <label>City</label>
            <input type="text"
                   tabIndex="4"
                   size="12"
                   value={cityFilter}
                   onChange={e => cityFilterChanged(e.target.value)} />
          </MediumField>
        </div>
        <div>
          <Checkbox>
            <input type="checkbox"
                   tabIndex="5"
                   id="not_expired"
                   checked={notExpFilter}
                   onChange={e => notExpFilterChanged(e.target.checked)} />
            <label>Not Expired</label>
          </Checkbox>
          <Checkbox>
            <input type="checkbox"
                   tabIndex="6"
                   id="expired"
                   checked={expiredFilter}
                   onChange={e => expiredFilterChanged(e.target.checked)} />
            <label>Expired</label>
          </Checkbox>
          <FilterStats>
            <table>
              <tbody>
                <tr>
                  <td className="propName">Records loaded:</td>
                  <td className="propValue">{commafy(props.items.length)}</td>
                </tr>
                <tr>
                  <td className="propName">Records displayed:</td>
                  <td className="propValue">{commafy(props.filteredItems.length)}</td>
                </tr>
              </tbody>
            </table>
          </FilterStats>

        </div>
      </FilterSection>
    </fieldset>
  )
}

const FilterSection = styled.section`
  display: flex;
  gap: 20px;

  label {
    font-family: georgia;
    font-size: 10pt;
    color: #00aad6;
  }

  input {
    font-family: consolas;
    font-size:10pt;
    background: #e8e8e8;
  }

  select {
    font-family: helvetica;
  }
`;
FilterSection.displayName = 'FilterSection';

const SmallField = styled.div`
  display: grid;
  grid-template-rows: 1em 1.5em;
  width: 80px;
`;
SmallField.displayName = 'SmallField';

const MediumField = styled.div`
  display: grid;
  grid-template-rows: 1em 1.5em;
  width: 120px;
`;
MediumField.displayName = 'MediumField';

const Checkbox = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 4px;
  width: 120px;

  & input {
    margin-right: 5px;
  }
`;

const FilterStats = styled.div`
  width: 14em;
  .propName {
    font-family: georgia;
    text-align: right;
  }
  .propValue {
    font-family: consolas;
    text-align: right;
  }
`;
FilterStats.displayName = 'FilterStats';

const mapStateToProps = state => ({
  items:          state.courtdist.items,
  filteredItems:  state.courtdist.filteredItems,
  filterCriteria: state.courtdist.filterCriteria
});

const mapDispatchToProps = { setFilterCriteria, setFilteredItems };

export default connect(mapStateToProps, mapDispatchToProps)(Filter);